/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-form-factory.ts to modify the generation of this file.




import * as BotChecker from 'src/helpers/Forms/Fields/BotChecker';
import * as CheckboxGroup from 'src/helpers/Forms/Fields/CheckboxGroup';
import * as ConsentCheckbox from 'src/helpers/Forms/Fields/ConsentCheckbox';
import * as Date from 'src/helpers/Forms/Fields/Date';
import * as Description from 'src/helpers/Forms/Fields/Description';
import * as Disclaimer from 'src/helpers/Forms/Fields/Disclaimer';
import * as Dropdown from 'src/helpers/Forms/Fields/Dropdown';
import * as Email from 'src/helpers/Forms/Fields/Email';
import * as Eyebrow from 'src/helpers/Forms/Fields/Eyebrow';
import * as Filler from 'src/helpers/Forms/Fields/Filler';
import * as Headline from 'src/helpers/Forms/Fields/Headline';
import * as Hidden from 'src/helpers/Forms/Fields/Hidden';
import * as LabelTooltip from 'src/helpers/Forms/Fields/LabelTooltip';
import * as Number from 'src/helpers/Forms/Fields/Number';
import * as Phone from 'src/helpers/Forms/Fields/Phone';
import * as RadioButton from 'src/helpers/Forms/Fields/RadioButton';
import * as ShortText from 'src/helpers/Forms/Fields/ShortText';
import * as TextArea from 'src/helpers/Forms/Fields/TextArea';
import * as TradeTypeDropDown from 'src/helpers/Forms/Fields/TradeTypeDropDown';
import * as ZIPCode from 'src/helpers/Forms/Fields/ZIPCode';
import * as ZippopotamusZIPCode from 'src/helpers/Forms/Fields/ZippopotamusZIPCode';
import * as Address from 'src/helpers/Forms/Fields/Address/Address';
import * as AddressUtils from 'src/helpers/Forms/Fields/Address/AddressUtils';
import * as AppointmentCalendar from 'src/helpers/Forms/Fields/AppointmentCalendar/AppointmentCalendar';
import * as ButtonCard from 'src/helpers/Forms/Fields/ButtonGroup/ButtonCard/ButtonCard';
import * as ButtonCardItem from 'src/helpers/Forms/Fields/ButtonGroup/ButtonCard/ButtonCardItem';
import * as TileButton from 'src/helpers/Forms/Fields/ButtonGroup/TileButton/TileButton';
import * as TileButtonItem from 'src/helpers/Forms/Fields/ButtonGroup/TileButton/TileButtonItem';
import * as OnlineSchedulingInitIframeInModal from 'src/helpers/Forms/Fields/Events/OnlineSchedulingInitIframeInModal';
import * as OnlineSchedulingInitInModal from 'src/helpers/Forms/Fields/Events/OnlineSchedulingInitInModal';
import * as OnlineSchedulingInitialPageLoad from 'src/helpers/Forms/Fields/Events/OnlineSchedulingInitialPageLoad';
import * as OnlineSchedulingTimeout from 'src/helpers/Forms/Fields/Events/OnlineSchedulingTimeout';
import * as SendMessageToParent from 'src/helpers/Forms/Fields/Events/SendMessageToParent';
import * as JobLocationDropdown from 'src/helpers/Forms/Fields/JobLocationDropdown/JobLocationDropdown';
import * as Button from 'src/helpers/Forms/Fields/NavigationButton/Button';
import * as NavigationButtonHelper from 'src/helpers/Forms/Fields/NavigationButton/NavigationButton.Helper';

const components = new Map();


components.set('BotChecker', BotChecker);
components.set('CheckboxGroup', CheckboxGroup);
components.set('ConsentCheckbox', ConsentCheckbox);
components.set('Date', Date);
components.set('Description', Description);
components.set('Disclaimer', Disclaimer);
components.set('Dropdown', Dropdown);
components.set('Email', Email);
components.set('Eyebrow', Eyebrow);
components.set('Filler', Filler);
components.set('Headline', Headline);
components.set('Hidden', Hidden);
components.set('LabelTooltip', LabelTooltip);
components.set('Number', Number);
components.set('Phone', Phone);
components.set('RadioButton', RadioButton);
components.set('ShortText', ShortText);
components.set('TextArea', TextArea);
components.set('TradeTypeDropDown', TradeTypeDropDown);
components.set('ZIPCode', ZIPCode);
components.set('ZippopotamusZIPCode', ZippopotamusZIPCode);
components.set('Address', Address);
components.set('AddressUtils', AddressUtils);
components.set('AppointmentCalendar', AppointmentCalendar);
components.set('ButtonCard', ButtonCard);
components.set('ButtonCardItem', ButtonCardItem);
components.set('TileButton', TileButton);
components.set('TileButtonItem', TileButtonItem);
components.set('OnlineSchedulingInitIframeInModal', OnlineSchedulingInitIframeInModal);
components.set('OnlineSchedulingInitInModal', OnlineSchedulingInitInModal);
components.set('OnlineSchedulingInitialPageLoad', OnlineSchedulingInitialPageLoad);
components.set('OnlineSchedulingTimeout', OnlineSchedulingTimeout);
components.set('SendMessageToParent', SendMessageToParent);
components.set('JobLocationDropdown', JobLocationDropdown);
components.set('Button', Button);
components.set('NavigationButton.Helper', NavigationButtonHelper);

import { FormFieldProps } from 'lib/forms';
import * as yup from 'yup';
import React from 'react';
// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// formFieldModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// formFieldFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.

export function formFieldModule(fieldName: string) {
  const component = components.get(fieldName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}

function formFieldComponent(fieldName: string, exportName?: string) {
  const component = components.get(fieldName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element();
  }

  if (exportName) {
    return component[exportName];
  }

  return component?.Default || component?.default || component;
}

// fieldFactory for react component
export function fieldFactoryComponent(props: FormFieldProps) {
  const fieldName = props.templateName?.replaceAll(' ', '');

  if (!fieldName) {
    return <></>;
  }

  const fieldComponent = formFieldComponent(fieldName);

  const key = props.id;

  if (fieldComponent) {
    return React.createElement(fieldComponent, {key, ...props});
  }

  return <></>;
}

// get field validation schema
export function fieldFactoryValidation(props: FormFieldProps, schema: yup.AnyObject) {
  const fieldName = props.templateName?.replaceAll(' ', '');

  if (!fieldName) {
    return;
  }

  const fieldModule = formFieldModule(fieldName);

  const getValidationSchema = fieldModule?.getValidationSchema;

  if (getValidationSchema) {
    return getValidationSchema(props, schema);
  }
}

//get Initial Value
export function initialFieldValueFactory(props: FormFieldProps, additionalDetails?: Record<string, unknown> | undefined) {
  const fieldName = props.templateName?.replaceAll(' ', '');

  if (!fieldName) {
    return;
  }

  const fieldModule = formFieldModule(fieldName);

  const getInitialValue = fieldModule?.getInitialValue;

  if (getInitialValue) {
    return getInitialValue(props, additionalDetails);
  }  }
